import { MessageCircle } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { MaskedLines } from "@/components/Reveal";
import { CONTACT } from "@/data/content";
import { scrollToHash } from "@/components/Navbar";
import { trackEvent, EVENTS } from "@/lib/analytics";

export const FinalCTA = () => (
    <section id="final-cta" data-testid="final-cta-section" className="blueprint noise relative overflow-hidden py-28 lg:py-40">
        <div className="pointer-events-none absolute left-1/2 top-1/2 h-[560px] w-[560px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-flame/10 blur-[160px]" />
        <div className="relative z-10 mx-auto max-w-5xl px-4 text-center sm:px-6">
            <Reveal>
                <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.3em] text-flame">Ready when you are</p>
            </Reveal>
            <MaskedLines
                className="mt-6 font-display font-black uppercase leading-[1.02] tracking-tight"
                lineClassName="text-4xl text-white sm:text-6xl lg:text-7xl"
                lines={[<>Your idea deserves</>, <>a <span className="text-flame">better way</span> to build.</>]}
            />
            <Reveal delay={0.4}>
                <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.3em] text-white/55">
                    From your first idea to your final key.
                </p>
            </Reveal>
            <Reveal delay={0.5}>
                <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
                    <button onClick={() => { trackEvent(EVENTS.estimateClick, { location: "final_cta" }); scrollToHash("#contact"); }}
                        data-testid="final-cta-estimate-btn"
                        className="ping-soft relative rounded-full bg-flame px-9 py-4 font-display text-sm font-bold uppercase tracking-[0.1em] text-white shadow-xl shadow-flame/25 transition-transform hover:-translate-y-0.5">
                        Get Free Estimate
                    </button>
                    <button onClick={() => scrollToHash("#contact")} data-testid="final-cta-consultation-btn"
                        className="rounded-full border border-white/25 px-9 py-4 font-display text-sm font-bold uppercase tracking-[0.1em] text-white transition-colors hover:border-flame hover:text-flame">
                        Book Consultation
                    </button>
                    <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="final-cta-whatsapp-btn"
                        onClick={() => trackEvent(EVENTS.whatsappClick, { location: "final_cta" })}
                        className="flex items-center gap-2 rounded-full border border-white/25 px-9 py-4 font-display text-sm font-bold uppercase tracking-[0.1em] text-white transition-colors hover:border-flame hover:text-flame">
                        <MessageCircle className="h-4 w-4 text-flame" /> Chat on WhatsApp
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);
